function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from 'prop-types';
import React from 'react';
import flow from 'lodash.flow';
import classnames from 'classnames';
import CountryInput from "./CountryInput";
import StateInput from "./StateInput";
import FormLabelGroup from "./FormLabelGroup";
import Col from "./Col";
import Input from "./Input";
import Row from "./Row";

var readEvent = function readEvent(e) {
  return _defineProperty({}, e.target.name, e.target.value);
};

export var addressPropType = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postal: PropTypes.string,
  countryCode: PropTypes.string
};

var AddressInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddressInput, _React$Component);

  var _super = _createSuper(AddressInput);

  function AddressInput() {
    var _this;

    _classCallCheck(this, AddressInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function (update) {
      _this.props.onChange(_objectSpread(_objectSpread({}, _this.props.value), update));
    };

    _this.propsFor = function (field) {
      if (_this.props.value[field] !== undefined) {
        return {
          value: _this.props.value[field]
        };
      }

      return {
        defaultValue: _this.props.defaultValue[field]
      };
    };

    _this.bindAddress1 = function (el) {
      _this.inputAddress1 = el;
    };

    return _this;
  }

  _createClass(AddressInput, [{
    key: "focus",
    value: function focus() {
      this.inputAddress1.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          countries = _this$props.countries,
          disabled = _this$props.disabled,
          error = _this$props.error,
          hints = _this$props.hints,
          id = _this$props.id,
          labels = _this$props.labels,
          _onBlur = _this$props.onBlur,
          showCountry = _this$props.showCountry,
          showLabels = _this$props.showLabels,
          inputName = _this$props.inputName;
      var inputId = id || 'addressInput';
      var address1Id = "".concat(inputId, "_address1");
      var address2Id = "".concat(inputId, "_address2");
      var cityId = "".concat(inputId, "_city");
      var stateId = "".concat(inputId, "_state");
      var postalId = "".concat(inputId, "_postal");
      var countryCodeId = "".concat(inputId, "_countryCode");
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          id: id
        },
        /*#__PURE__*/
        React.createElement(FormLabelGroup, {
          label: labels.address1,
          inputId: address1Id,
          srLabel: !showLabels,
          feedback: error.address1,
          hint: hints.address1,
          stacked: true
        },
        /*#__PURE__*/
        React.createElement(Input, _extends({
          autoComplete: "address-line1",
          id: address1Id,
          name: inputName.address1,
          type: "text",
          placeholder: labels.address1
        }, this.propsFor(inputName.address1), {
          invalid: !!error.address1,
          onBlur: function onBlur() {
            return _onBlur(inputName.address1);
          },
          onChange: flow([readEvent, this.onChange]),
          disabled: disabled,
          ref: this.bindAddress1
        }))),
        /*#__PURE__*/
        React.createElement(FormLabelGroup, {
          label: labels.address2,
          inputId: address2Id,
          srLabel: !showLabels,
          error: error.address2,
          feedback: error.address2,
          hint: hints.address2,
          stacked: true
        },
        /*#__PURE__*/
        React.createElement(Input, _extends({
          autoComplete: "address-line2",
          id: address2Id,
          name: inputName.address2,
          type: "text",
          placeholder: labels.address2
        }, this.propsFor(inputName.address2), {
          invalid: !!error.address2,
          onBlur: function onBlur() {
            return _onBlur(inputName.address2);
          },
          onChange: flow([readEvent, this.onChange]),
          disabled: disabled
        }))),
        /*#__PURE__*/
        React.createElement(Row, {
          className: "no-gutters"
        },
        /*#__PURE__*/
        React.createElement(Col, {
          sm: 6,
          xs: 12,
          className: "pr-sm-3"
        },
        /*#__PURE__*/
        React.createElement(FormLabelGroup, {
          rowClassName: classnames({
            'mb-sm-0': !showCountry
          }),
          feedback: error.city,
          hint: hints.city,
          label: labels.city,
          inputId: cityId,
          srLabel: !showLabels,
          stacked: true
        },
        /*#__PURE__*/
        React.createElement(Input, _extends({
          autoComplete: "address-level2",
          id: cityId,
          type: "text",
          name: inputName.city,
          placeholder: labels.city
        }, this.propsFor(inputName.city), {
          invalid: !!error.city,
          onBlur: function onBlur() {
            return _onBlur(inputName.city);
          },
          onChange: flow([readEvent, this.onChange]),
          disabled: disabled
        })))),
        /*#__PURE__*/
        React.createElement(Col, {
          md: 2,
          sm: 3,
          xs: 4,
          className: "pr-3"
        },
        /*#__PURE__*/
        React.createElement(FormLabelGroup, {
          rowClassName: classnames({
            'mb-0': !showCountry
          }),
          feedback: error.state,
          hint: hints.state,
          label: labels.state,
          inputId: stateId,
          srLabel: !showLabels,
          stacked: true
        },
        /*#__PURE__*/
        React.createElement(StateInput, _extends({
          autoComplete: "address-level1",
          className: "w-100",
          countries: countries,
          id: stateId,
          name: inputName.state,
          placeholder: labels.state
        }, this.propsFor(inputName.state), {
          invalid: !!error.state,
          onBlur: function onBlur() {
            return _onBlur(inputName.state);
          },
          onChange: function onChange(state) {
            return _this2.onChange(_defineProperty({}, inputName.state, state));
          },
          disabled: disabled
        })))),
        /*#__PURE__*/
        React.createElement(Col, {
          md: 4,
          sm: 3,
          xs: 8
        },
        /*#__PURE__*/
        React.createElement(FormLabelGroup, {
          rowClassName: classnames({
            'mb-0': !showCountry
          }),
          label: labels.postal,
          inputId: postalId,
          srLabel: !showLabels,
          feedback: error.postal,
          hint: hints.postal,
          stacked: true
        },
        /*#__PURE__*/
        React.createElement(Input, _extends({
          autoComplete: "postal-code",
          id: postalId,
          type: "text",
          name: inputName.postal,
          placeholder: labels.postal
        }, this.propsFor(inputName.postal), {
          invalid: !!error.postal,
          onBlur: function onBlur() {
            return _onBlur(inputName.postal);
          },
          onChange: flow([readEvent, this.onChange]),
          disabled: disabled
        }))))), showCountry &&
        /*#__PURE__*/
        React.createElement(FormLabelGroup, {
          feedback: error.countryCode,
          hint: hints.countryCode,
          rowClassName: "mb-0",
          label: labels.countryCode,
          inputId: countryCodeId,
          srLabel: !showLabels,
          stacked: true
        },
        /*#__PURE__*/
        React.createElement(CountryInput, _extends({
          autoComplete: "country",
          className: "w-100",
          id: countryCodeId,
          name: inputName.countryCode,
          placeholder: labels.countryCode
        }, this.propsFor(inputName.countryCode), {
          invalid: !!error.countryCode,
          onBlur: function onBlur() {
            return _onBlur(inputName.countryCode);
          },
          onChange: function onChange(countryCode) {
            return _this2.onChange(_defineProperty({}, inputName.countryCode, countryCode));
          },
          disabled: disabled
        }))))
      );
    }
  }]);

  return AddressInput;
}(React.Component);

AddressInput.propTypes = {
  className: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.string),
  defaultValue: PropTypes.object,
  inputName: PropTypes.shape(addressPropType),
  disabled: PropTypes.bool,
  error: PropTypes.shape(addressPropType),
  hints: PropTypes.shape(addressPropType),
  id: PropTypes.string,
  labels: PropTypes.shape(addressPropType),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  showCountry: PropTypes.bool,
  showLabels: PropTypes.bool,
  value: PropTypes.object
};
AddressInput.defaultProps = {
  className: '',
  defaultValue: {},
  disabled: false,
  error: {},
  hints: {},
  labels: {
    address1: 'Address',
    address2: 'Address 2',
    city: 'City',
    state: 'State',
    postal: 'Zip',
    countryCode: 'Country'
  },
  inputName: {
    address1: 'address1',
    address2: 'address2',
    city: 'city',
    state: 'state',
    postal: 'postal',
    countryCode: 'countryCode'
  },
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  showCountry: true,
  showLabels: false,
  value: {}
};
AddressInput.displayName = "AddressInput";
export default AddressInput;